import * as R from 'ramda';

const show = store => async (state, show) => {
    const userClientId = state.user.selectedUserClientId;

    store.setState(
        R.assocPath(
            ['clients', userClientId, 'reports', 'show'],
            show,
            store.getState(),
        ),
        true,
    );
};

export default show;
